import { api } from 'api';

const URL = '/listings/cities';
const LIMIT = 100;

const getCities = async () => {
  const {
    data: { count, results },
  } = await api.get(URL, { params: { limit: LIMIT, skip: 0 } });
  const requests = [];

  for (let i = 0; i < Math.ceil(count / LIMIT) - 1; i += 1) {
    requests.push(api.get(URL, { params: { limit: LIMIT, skip: LIMIT * (i + 1) } }));
  }

  return Promise.all(requests).then((response) =>
    response.reduce(
      (acc, { data }) => {
        acc.push(...data.results);
        return acc;
      },
      [...results]
    ));
};

export default getCities;
